

// socketService.js
let socket = null;
export const connectSocket = (token,messageHandler) => {

    // console.log(token)
  
  socket = new WebSocket(
    `wss://v3nn69l97d.execute-api.ap-south-1.amazonaws.com/dev?token=${token}`
  );

  socket.onopen = () => {
    
  };

  socket.onmessage = (event) => {
    if(messageHandler){
      messageHandler(event.data);
    }
    
  };

  socket.onclose = () => {
   
  };

  socket.onerror = (error) => {
    console.error("WebSocket error:", error);
  };

  return socket;
};

export const sendMessage = (msg) => {
  if (socket && socket.readyState === WebSocket.OPEN) {
    socket.send(JSON.stringify(msg));
  } else {
    console.error(" WebSocket not connected");
  }
};

export const disconnectSocket = () => {
  if (socket) {
    socket.close();
    socket = null;
  }
};
